export interface BranchRequestBody {
  skip: number;
  take: number;
  filter: {
    radius: {
      lat: number;
      lon: number;
      distance_miles: number;
    };
  };
  sort: {
    distance: {
      lat: number;
      lon: number;
    };
  };
}

export const createNearestBranchRequestBody = (lat: number, long: number): BranchRequestBody => ({
  skip: 0,
  take: 25,
  filter: {
    radius: {
      lat,
      lon: long,
      distance_miles: 250,
    },
  },
  sort: {
    distance: {
      lat,
      lon: long,
    },
  },
});
